module.exports = __webpack_public_path__ + "assets/img/default_player.png?5c43d4b591a914b6e1971f3d74fb968c";